module.exports = __webpack_public_path__ + "static/img/03.2114ea57.jpg";